import {
  usePlayersStore,
  useSessionStore,
} from "@/stores";
import type {
  Player
} from "@/types";
export function updateSeat([seatIndex, playerId]: [number, string]) {
  const session = useSessionStore();
  if (session.isPlayerOrSpectator) return;
  const playersStore = usePlayersStore();
  const player = playersStore.players[seatIndex];
  // check if player is already seated
  const oldSeat = playersStore.players.findIndex(
    (p: Player) => p.id === playerId
  );
  if (oldSeat > -1 && oldSeat !== seatIndex) {
    const oldPlayer = playersStore.players[oldSeat];
    if (oldPlayer) {
      playersStore.update({
        player: oldPlayer,
        property: "id",
        value: "",
      });
    }
  }
  if (!player) return;
  playersStore.update({
    player,
    property: "id",
    value: playerId,
  });
}
